import React, { useState } from 'react'
import { Container, Row, Col, Card, Button, Nav, Tab } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css';
import { toolsList } from '../data/toolsData';
import '../styles/Tools.css'

// Tool categories
const categories = {
  all: "All Tools",
  productivity: "Productivity",
  resume: "Resume Tools",
  university: "University Resources"
};

const Tools = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  
  const filteredTools = activeCategory === 'all' 
    ? toolsList 
    : toolsList.filter(tool => tool.category === activeCategory);

  return (
    <Container className="page-container tools-container">
      <h1 className="section-title">Explore Our Tools</h1>
      <p className="text-center mb-5">Browse through our collection of micro-tools designed to simplify your tasks</p>

      <Tab.Container id="tools-tabs" defaultActiveKey="all">
        <div className="tools-tabs-container">
          <Nav variant="pills" className="tools-nav">
            {Object.entries(categories).map(([key, value]) => (
              <Nav.Item key={key}>
                <Nav.Link 
                  eventKey={key} 
                  onClick={() => setActiveCategory(key)}
                  className="tools-nav-link"
                >
                  {value}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </div>

        <Tab.Content>
          <Tab.Pane eventKey={activeCategory}>
            <Row className="mt-4">
              {filteredTools.map(tool => (
                <Col md={6} lg={4} key={tool.id} className="mb-4">
                  <Card className="tool-card">
                    <Card.Body>
                      <div className="tool-icon">{tool.icon}</div>
                      <Card.Title className="tool-card-title">{tool.title}</Card.Title>
                      <Card.Text className="tool-card-text">
                        {tool.description}
                      </Card.Text>
                      <Button as={Link} to={tool.path} className="tool-button">
                        Try Now <i className="la la-arrow-right ms-2" style={{ fontSize: '18px' }} aria-hidden="true"></i>
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </Container>
  )
}

export default Tools